import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fafefd' },
    '2': { value: '#f3fbf9' },
    '3': { value: '#e0f8f3' },
    '4': { value: '#ccf3ea' },
    '5': { value: '#b8eae0' },
    '6': { value: '#a1ded2' },
    '7': { value: '#83cdc1' },
    '8': { value: '#53b9ab' },
    '9': { value: '#12a594' },
    '10': { value: '#0d9b8a' },
    '11': { value: '#008573' },
    '12': { value: '#0d3d38' },
    a1: { value: '#00cc9905' },
    a2: { value: '#00aa800c' },
    a3: { value: '#00c69d1f' },
    a4: { value: '#00c39633' },
    a5: { value: '#00b49047' },
    a6: { value: '#00a6855e' },
    a7: { value: '#0099807c' },
    a8: { value: '#009783ac' },
    a9: { value: '#009e8ced' },
    a10: { value: '#009684f2' },
    a11: { value: '#008573' },
    a12: { value: '#00332df2' },
  },
  dark: {
    '1': { value: '#0d1514' },
    '2': { value: '#111c1b' },
    '3': { value: '#0d2d2a' },
    '4': { value: '#023b37' },
    '5': { value: '#084843' },
    '6': { value: '#145750' },
    '7': { value: '#1c6961' },
    '8': { value: '#207e73' },
    '9': { value: '#12a594' },
    '10': { value: '#0eb39e' },
    '11': { value: '#0bd8b6' },
    '12': { value: '#adf0dd' },
    a1: { value: '#00deab05' },
    a2: { value: '#12fbe60c' },
    a3: { value: '#00ffe61e' },
    a4: { value: '#00ffe92d' },
    a5: { value: '#00ffea3b' },
    a6: { value: '#1cffe84b' },
    a7: { value: '#2efde85f' },
    a8: { value: '#32ffe775' },
    a9: { value: '#13ffe49f' },
    a10: { value: '#0dffe0ae' },
    a11: { value: '#0afed5d6' },
    a12: { value: '#b8ffebef' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.teal.light.1}', _dark: '{colors.teal.dark.1}' } },
  '2': { value: { _light: '{colors.teal.light.2}', _dark: '{colors.teal.dark.2}' } },
  '3': { value: { _light: '{colors.teal.light.3}', _dark: '{colors.teal.dark.3}' } },
  '4': { value: { _light: '{colors.teal.light.4}', _dark: '{colors.teal.dark.4}' } },
  '5': { value: { _light: '{colors.teal.light.5}', _dark: '{colors.teal.dark.5}' } },
  '6': { value: { _light: '{colors.teal.light.6}', _dark: '{colors.teal.dark.6}' } },
  '7': { value: { _light: '{colors.teal.light.7}', _dark: '{colors.teal.dark.7}' } },
  '8': { value: { _light: '{colors.teal.light.8}', _dark: '{colors.teal.dark.8}' } },
  '9': { value: { _light: '{colors.teal.light.9}', _dark: '{colors.teal.dark.9}' } },
  '10': { value: { _light: '{colors.teal.light.10}', _dark: '{colors.teal.dark.10}' } },
  '11': { value: { _light: '{colors.teal.light.11}', _dark: '{colors.teal.dark.11}' } },
  '12': { value: { _light: '{colors.teal.light.12}', _dark: '{colors.teal.dark.12}' } },
  a1: { value: { _light: '{colors.teal.light.a1}', _dark: '{colors.teal.dark.a1}' } },
  a2: { value: { _light: '{colors.teal.light.a2}', _dark: '{colors.teal.dark.a2}' } },
  a3: { value: { _light: '{colors.teal.light.a3}', _dark: '{colors.teal.dark.a3}' } },
  a4: { value: { _light: '{colors.teal.light.a4}', _dark: '{colors.teal.dark.a4}' } },
  a5: { value: { _light: '{colors.teal.light.a5}', _dark: '{colors.teal.dark.a5}' } },
  a6: { value: { _light: '{colors.teal.light.a6}', _dark: '{colors.teal.dark.a6}' } },
  a7: { value: { _light: '{colors.teal.light.a7}', _dark: '{colors.teal.dark.a7}' } },
  a8: { value: { _light: '{colors.teal.light.a8}', _dark: '{colors.teal.dark.a8}' } },
  a9: { value: { _light: '{colors.teal.light.a9}', _dark: '{colors.teal.dark.a9}' } },
  a10: { value: { _light: '{colors.teal.light.a10}', _dark: '{colors.teal.dark.a10}' } },
  a11: { value: { _light: '{colors.teal.light.a11}', _dark: '{colors.teal.dark.a11}' } },
  a12: { value: { _light: '{colors.teal.light.a12}', _dark: '{colors.teal.dark.a12}' } },
  default: { value: { _light: '{colors.teal.light.9}', _dark: '{colors.teal.dark.9}' } },
  emphasized: { value: { _light: '{colors.teal.light.10}', _dark: '{colors.teal.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.teal.light.a11}', _dark: '{colors.teal.dark.a11}' } },
})

export default {
  name: 'teal',
  tokens,
  semanticTokens,
}
